import React, { memo } from 'react';
import { withBlokWrapper } from '../../../BlokWrapper/BlokWrapper';
import { Theme } from '../../../../interfaces/enums/Theme.enum';

interface QuoteStageHeadingBarProps {
  heading: string;
}

const QuoteStageHeadingBar: React.FC<QuoteStageHeadingBarProps> = ({
  heading,
}) => {
  return (
    <div className="px-10 py-6">
      <h2 className="font-dm-serif-display text-text/body text-2xl">
        {heading}
      </h2>
    </div>
  );
};

export default memo(withBlokWrapper(QuoteStageHeadingBar, Theme.DARKEST));
